import Skeleton from '@carvana/ds-skeleton';
import React from 'react';
import {
  TileContainer,
  TileContentWrapper
} from '../MerchTile/MerchTile.styles';

export default function LoadingTile() {
  return (
    <div data-package="merch-tile" className="h-full">
      <TileContainer
        className="border-border-skeleton hover:border-border-skeleton"
        hasBorder
      >
        <TileContentWrapper>
          <Skeleton height="100%" width="100%" className="rounded-none" />

          <div className="flex flex-col gap-xl p-xl">
            <div className="flex flex-col gap-sm">
              <Skeleton height="24px" width="144px" />
              <Skeleton height="24px" width="200px" />
            </div>

            <div className="flex flex-col gap-md">
              <Skeleton height="28px" width="88px" />
              <div className="flex flex-col gap-sm">
                <Skeleton height="24px" width="144px" />
                <Skeleton height="24px" width="88px" />
              </div>
            </div>

            <Skeleton height="20px" width="200px" />
          </div>
        </TileContentWrapper>
      </TileContainer>
    </div>
  );
}
